module.exports = __webpack_public_path__ + "static/img/eg.f9ab7974.svg";